'use client';

import { Image, ImageCircleItem, Typography } from '@musinsa/mds';
import { useQuery } from '@tanstack/react-query';
import { twMerge } from 'tailwind-merge';
import { getCdnUrl } from '../../common/utils/getCdnUrl';
import { curatorQueries } from '../../query-factory';

interface Props {
  className?: string;
}

export const ProfileInfo = ({ className }: Props) => {
  const userInfoQuery = useQuery({
    ...curatorQueries.profile.userInfo,
  });
  const snsTitle = userInfoQuery.data?.snsTitle ?? '';
  const profileQuery = useQuery({
    ...curatorQueries.profile.profileBySnsTitle(snsTitle),
    enabled: Boolean(snsTitle),
  });

  const isPending = userInfoQuery.isPending || profileQuery.isPending;

  return (
    <div
      className={twMerge(
        'flex items-center gap-[12px]! px-[16px]! pt-[24px]! pb-[8px]!',
        className,
      )}
    >
      <ImageCircleItem size="56">
        <Image
          src={
            isPending || !profileQuery.data?.profileImage
              ? getCdnUrl('/images/profile/common/default.png')
              : `${profileQuery.data?.profileImage}?width=112&q=75&format=webp`
          }
          alt="profile"
        />
      </ImageCircleItem>
      {/* TODO: Nickname 로딩 처리 */}
      <Typography variant="body14pxMed">{profileQuery.data?.nickname}</Typography>
    </div>
  );
};
